/*
 * @Author: liushumin
 * @Date: 2022-09-22 09:15:21
 * @LastEditTime: 2022-09-27 18:14:06
 * @LastEditors: liushumin
 */
import Vue from 'vue'

const szData = {
  state: {
    szDetailsObj: [],
    szFareDetails: {},
    receiverObj: {}
    
  },
  mutations: {

  },
  actions: {
  
  }
}

export default szData
